"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckbox = exports.useImageInput = exports.useFileInput = exports.useInput = void 0;
var react_1 = require("react");
var image_set_1 = require("../model/image-set");
var util_1 = require("../util");
;
function useInput(initialValue) {
    var validate = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        validate[_i - 1] = arguments[_i];
    }
    var _a = react_1.useState(initialValue), value = _a[0], setValue = _a[1];
    return {
        value: value,
        setValue: setValue,
        reset: function () { return setValue(initialValue); },
        validate: validate,
        bind: {
            value: value,
            onChange: function (event) {
                var newValue = event.target.value;
                if (event.target.hasAttribute('required')) {
                    if (newValue === '') {
                        event.target.classList.add('is-invalid');
                    }
                    else {
                        event.target.classList.remove('is-invalid');
                    }
                }
                setValue(newValue);
            }
        }
    };
}
exports.useInput = useInput;
function useFileInput(initialValue) {
    var _a = react_1.useState(initialValue), value = _a[0], setValue = _a[1];
    return {
        value: value,
        setValue: setValue,
        reset: function () { return setValue(initialValue); },
        bind: {
            onChange: function (event) {
                var _a, _b;
                if ((_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) {
                    var data = event.target.files[0];
                    setValue(data);
                }
            }
        }
    };
}
exports.useFileInput = useFileInput;
function useImageInput(initialValue) {
    var _a = react_1.useState(initialValue), value = _a[0], setValue = _a[1];
    var _b = react_1.useState(new image_set_1.ImageMeta()), asImage = _b[0], setAsImage = _b[1];
    return {
        value: value,
        setValue: setValue,
        asImage: asImage,
        setAsImage: setAsImage,
        reset: function () { return setValue(initialValue); },
        bind: {
            onChange: function (event) {
                var _a, _b;
                if ((_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) {
                    var data = event.target.files[0];
                    setValue(data);
                    util_1.getImageData(data).then(function (img) {
                        setAsImage(img);
                    });
                }
            }
        }
    };
}
exports.useImageInput = useImageInput;
function useCheckbox(initialValue) {
    var _a = react_1.useState(initialValue), checked = _a[0], setChecked = _a[1];
    return {
        isChecked: checked,
        setChecked: setChecked,
        reset: function () { return setChecked(initialValue); },
        bind: {
            checked: checked,
            onChange: function (event) {
                setChecked(event.target.checked);
            }
        }
    };
}
exports.useCheckbox = useCheckbox;
